import LegalPageLayout from './LegalPageLayout';

export default function MentionsLegales() {
  return <LegalPageLayout pageKey="mentions" />;
}
